module.exports = __webpack_public_path__ + "img/ss_ye-06.f836e0a9.jpg";